import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/appuser/cancard-frontend/src/components/form/auth/forgot-password/forgot-password_form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/appuser/cancard-frontend/src/components/form/auth/login/login-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/appuser/cancard-frontend/src/components/form/auth/reset-password/reset-password_form.tsx");
